import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AgencyDetails, AgencyDetailsSage, Reinsurer } from '../../core/model/reinsurer.model'
import { MatDialogRef } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { Store, select } from '@ngrx/store'
import { AppState } from '../../core/store/index'
import {
  selectCurrentClient,
  selectCurrentClientStudies,
  selectCurrentStudyID,
} from '../../core/store/broker/broker.selectors'
import { Study } from '../../core/model/study.model'
import {
  selectSelectedStudyReinsurers,
  selectStudyReinsurersSaving,
} from '../store/reinsurers.selectors'
import {
  removeAgencySeqFromReinsurerDirty,
  saveAgencyDetails,
  setUpdateOneReinsurer,
  updateOrAddStudiesReinsurerDirty,
  updateReinsurer,
} from '../store/study-reinsurers.actions'
import { selectAccountOpportunities } from 'src/app/core/store/accountopportunity.selectors'
import { AccountOpportunity } from 'src/app/api/model/backend.model'
import { Client } from 'src/app/core/model/client.model'
import { AgencyDetailDialogComponent } from '../agency-detail-component/agency-detail.component'
import { AsyncPipe } from '@angular/common'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-agency-detail-dialog-container',
  templateUrl: './agency-detail.container.html',
  imports: [AgencyDetailDialogComponent, AsyncPipe],
})
export class AgencyDetailDialogContainerComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AgencyDetailDialogContainerComponent>>(MatDialogRef)
  data = inject<{
    reinsurer: Reinsurer
    select: string
    agencyDetails: AgencyDetails[]
  }>(MAT_DIALOG_DATA)
  private store = inject<Store<AppState>>(Store)

  studyID$: Observable<string | null>
  reinsurers$: Observable<Reinsurer[] | null>
  studies$: Observable<readonly Study[]>
  savingReinsurer$: Observable<boolean>
  currentClient$: Observable<Client | null>
  accountOpportunities$: Observable<AccountOpportunity[]>

  ngOnInit(): void {
    this.studyID$ = this.store.pipe(select(selectCurrentStudyID))
    this.reinsurers$ = this.store.pipe(select(selectSelectedStudyReinsurers))
    this.studies$ = this.store.pipe(select(selectCurrentClientStudies))
    this.savingReinsurer$ = this.store.pipe(select(selectStudyReinsurersSaving))
    this.accountOpportunities$ = this.store.pipe(select(selectAccountOpportunities))
    this.currentClient$ = this.store.pipe(select(selectCurrentClient))
  }

  onSetReinsurer(value: { programID: string; reinsurer: Reinsurer }): void {
    this.store.dispatch(setUpdateOneReinsurer(value))
  }

  onUpdateOrAddDirty(reinsurer: Reinsurer): void {
    this.store.dispatch(updateOrAddStudiesReinsurerDirty({ reinsurer }))
  }

  onDeselectAgencyRelationship(details: AgencyDetails): void {
    this.store.dispatch(
      removeAgencySeqFromReinsurerDirty({
        agencyTPRef: details.agencyTPRef,
        sequenceNumber: details.agencySeqNumber,
      }),
    )
  }

  onSaveClick(): void {
    this.store.dispatch(updateReinsurer())
  }

  onSaveNewOBO(agencyDetails: AgencyDetailsSage[]): void {
    this.store.dispatch(saveAgencyDetails({ agencyDetails }))
  }
}
